/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */
import { useState } from "react";
import { Icon } from "../../ui";
import { useIsMobile } from "../../hooks/useIsMobile";

import { ACADEMY } from "../../lib/data/academy";
import { LESSONS } from "../../lib/data/lessons";
export function AcademyPage({ user, lang }) {
  const [chapter,  setChapter]  = useState(null);
  const [lesson,   setLesson]   = useState(null);
  const [phase,    setPhase]    = useState("read"); // "read" | "quiz" | "result"
  const [answers,  setAnswers]  = useState({});     // { qIdx: chosenIdx }
  const [done,     setDone]     = useState([]);     // completed lesson ids
  const isMobile = useIsMobile();

  const totalLessons = ACADEMY.reduce((s,ch)=>s+ch.videos.length,0);
  const overallPct   = Math.round((done.length/totalLessons)*100);

  // ── helpers ──────────────────────────────────────────────────────────────────
  function openLesson(v) { setLesson(v); setPhase("read"); setAnswers({}); }
  function startQuiz()   { setPhase("quiz"); setAnswers({}); }
  function submitQuiz()  { setPhase("result"); }
  function completeLesson() {
    if (!done.includes(lesson.id)) setDone(d=>[...d,lesson.id]);
    setLesson(null); setPhase("read"); setAnswers({});
  }

  function quizScore() {
    const qs = LESSONS[lesson?.id]?.quiz || [];
    return qs.filter((q,i)=>answers[i]===q.correct).length;
  }
  function quizTotal() { return LESSONS[lesson?.id]?.quiz?.length || 0; }
  function passed()    { return quizTotal()>0 && quizScore()/quizTotal()>=0.75; }

  // ── Render a lesson block ─────────────────────────────────────────────────────
  function renderBlock(b, i) {
    switch(b.type) {
      case "h":  return <div key={i} style={{fontWeight:900,fontSize:18,color:"var(--green)",marginBottom:6,marginTop:i>0?20:0,borderBottom:"2px solid var(--green-light)",paddingBottom:6}}>{b.text}</div>;
      case "h2": return <div key={i} style={{fontWeight:800,fontSize:15,color:"var(--text-primary)",marginBottom:5,marginTop:14}}>{b.text}</div>;
      case "p":  return <div key={i} style={{fontSize:14,color:"var(--text-secondary)",lineHeight:1.75,marginBottom:10}}>{b.text}</div>;
      case "bullet": return (
        <ul key={i} style={{margin:"0 0 12px 0",paddingLeft:20,display:"flex",flexDirection:"column",gap:5}}>
          {b.items.map((item,j)=>(
            <li key={j} style={{fontSize:13,color:"var(--text-secondary)",lineHeight:1.65}}>{item}</li>
          ))}
        </ul>
      );
      case "warn": return (
        <div key={i} style={{background:"#FFFBEB",border:"1.5px solid #FCD34D",borderRadius:12,padding:"12px 16px",marginBottom:12,marginTop:8,display:"flex",gap:10}}>
          <span style={{fontSize:18,flexShrink:0}}>⚠️</span>
          <span style={{fontSize:13,fontWeight:700,color:"#92400E",lineHeight:1.6}}>{b.text}</span>
        </div>
      );
      default: return null;
    }
  }

  // ── CHAPTER LIST ─────────────────────────────────────────────────────────────
  function ChapterList() {
    return (
      <div style={{display:"flex",flexDirection:"column",gap:10}}>
        <div style={{background:"var(--green)",borderRadius:16,padding:"14px 16px",marginBottom:4}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:6}}>
            <span style={{fontWeight:800,fontSize:13,color:"#fff"}}>{lang==="gr"?"Συνολική Πρόοδος":"Overall Progress"}</span>
            <span style={{fontFamily:"Bebas Neue,sans-serif",fontSize:22,color:"var(--lime)",letterSpacing:1}}>{overallPct}%</span>
          </div>
          <div style={{height:6,background:"rgba(255,255,255,0.2)",borderRadius:4}}>
            <div style={{height:"100%",width:`${overallPct}%`,background:"var(--lime)",borderRadius:4,transition:"width 0.4s"}}/>
          </div>
          <div style={{fontSize:11,color:"rgba(255,255,255,0.65)",marginTop:5}}>{done.length} / {totalLessons} {lang==="gr"?"ολοκληρώθηκαν":"completed"}</div>
        </div>
        {ACADEMY.map(ch=>{
          const chDone = ch.videos.filter(v=>done.includes(v.id)).length;
          const pct    = Math.round((chDone/ch.videos.length)*100);
          const active = chapter?.id===ch.id;
          return (
            <div key={ch.id} onClick={()=>{setChapter(ch);setLesson(null);}} style={{background:"var(--surface)",border:`1.5px solid ${active?"var(--green)":"var(--border)"}`,borderRadius:16,padding:"14px 16px",cursor:"pointer",transition:"all 0.15s",boxShadow:active?"0 0 0 3px rgba(27,67,50,0.08)":"none"}}>
              <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:8}}>
                <span style={{fontSize:20}}>{ch.icon}</span>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{fontWeight:800,fontSize:13,color:"var(--text-primary)"}}>{lang==="gr"?ch.titleGr:ch.title}</div>
                  <div style={{fontSize:11,color:"var(--text-muted)",marginTop:1}}>{ch.videos.length} {lang==="gr"?"μαθήματα":"lessons"} · {chDone}/{ch.videos.length} done</div>
                </div>
                {pct===100 ? <span style={{background:"var(--lime)",color:"var(--text-primary)",fontSize:10,padding:"2px 9px",borderRadius:20,fontWeight:800}}>✓</span>
                 : pct>0 ? <span style={{fontSize:11,fontWeight:700,color:"var(--green)"}}>{pct}%</span> : null}
              </div>
              <div style={{height:4,background:"var(--surface3)",borderRadius:4,overflow:"hidden"}}>
                <div style={{height:"100%",width:`${pct}%`,background:"var(--green)",borderRadius:4,transition:"width 0.4s"}}/>
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  // ── LESSON LIST ───────────────────────────────────────────────────────────────
  function LessonList({ch}) {
    return (
      <div>
        <button onClick={()=>{setChapter(null);setLesson(null);}} style={{display:"flex",alignItems:"center",gap:6,background:"none",border:"none",cursor:"pointer",color:"var(--text-muted)",fontSize:12,fontWeight:700,marginBottom:14,padding:0}}>
          <Icon name="back" size={14}/> {lang==="gr"?"Πίσω":"Back"}
        </button>
        <div style={{background:"var(--surface)",border:"1px solid var(--border)",borderRadius:16,padding:"16px 18px",marginBottom:14}}>
          <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:4}}>
            <span style={{fontSize:24}}>{ch.icon}</span>
            <div>
              <div style={{fontWeight:800,fontSize:16,color:"var(--text-primary)"}}>{lang==="gr"?ch.titleGr:ch.title}</div>
              <div style={{fontSize:12,color:"var(--text-muted)",marginTop:2}}>{lang==="gr"?ch.descGr:ch.desc}</div>
            </div>
          </div>
        </div>
        <div style={{display:"flex",flexDirection:"column",gap:8}}>
          {ch.videos.map(v=>{
            const isDone = done.includes(v.id);
            return (
              <div key={v.id} onClick={()=>openLesson(v)} style={{background:"var(--surface)",border:"1.5px solid var(--border)",borderRadius:14,padding:"14px 16px",cursor:"pointer",display:"flex",alignItems:"center",gap:12,transition:"all 0.15s"}}>
                <div style={{width:40,height:40,background:isDone?"var(--lime)":"var(--green)",borderRadius:12,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                  {isDone ? <span style={{color:"var(--text-primary)",fontSize:16,fontWeight:900}}>✓</span> : <span style={{color:"var(--lime)",fontSize:14,fontWeight:800}}>📖</span>}
                </div>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{fontWeight:700,fontSize:13,color:"var(--text-primary)"}}>{v.title}</div>
                  <div style={{fontSize:11,color:"var(--text-muted)",marginTop:2,display:"flex",gap:8,flexWrap:"wrap"}}>
                    <span>🕐 {v.dur}</span>
                    <span style={{background:"var(--green-light)",color:"var(--green)",padding:"1px 7px",borderRadius:20,fontSize:10,fontWeight:700}}>SOP: {v.sop}</span>
                    {LESSONS[v.id] && <span style={{background:"#EFF6FF",color:"#1D4ED8",padding:"1px 7px",borderRadius:20,fontSize:10,fontWeight:700}}>{LESSONS[v.id].quiz.length} Q quiz</span>}
                  </div>
                </div>
                <Icon name="arrow" size={16}/>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  // ── LESSON READER ─────────────────────────────────────────────────────────────
  function LessonReader() {
    const ld = LESSONS[lesson.id];
    return (
      <div>
        <button onClick={()=>setLesson(null)} style={{display:"flex",alignItems:"center",gap:6,background:"none",border:"none",cursor:"pointer",color:"var(--text-muted)",fontSize:12,fontWeight:700,marginBottom:16,padding:0}}>
          <Icon name="back" size={14}/> {lang==="gr"?"Πίσω στα μαθήματα":"Back to lessons"}
        </button>

        {/* SOP badge */}
        <div style={{display:"flex",gap:8,marginBottom:16,flexWrap:"wrap"}}>
          <span style={{background:"var(--green-light)",color:"var(--green)",fontSize:11,fontWeight:700,padding:"4px 12px",borderRadius:20}}>SOP: {lesson.sop}</span>
          {done.includes(lesson.id) && <span style={{background:"var(--lime)",color:"var(--text-primary)",fontSize:11,fontWeight:800,padding:"4px 12px",borderRadius:20}}>✓ {lang==="gr"?"Ολοκληρώθηκε":"Completed"}</span>}
        </div>

        {/* Content */}
        {ld ? (
          <div style={{background:"var(--surface)",border:"1px solid var(--border)",borderRadius:18,padding:"22px 24px",marginBottom:16}}>
            {ld.content.map((b,i)=>renderBlock(b,i))}
          </div>
        ) : (
          <div style={{background:"var(--surface)",border:"1px solid var(--border)",borderRadius:18,padding:"22px 24px",marginBottom:16,textAlign:"center",color:"var(--text-muted)"}}>
            <div style={{fontSize:32,marginBottom:8}}>📄</div>
            <div style={{fontWeight:700}}>{lang==="gr"?"Περιεχόμενο σύντομα":"Content coming soon"}</div>
          </div>
        )}

        {/* CTA */}
        {!done.includes(lesson.id) && ld && (
          <button className="btn-base btn-green" style={{width:"100%",justifyContent:"center",fontSize:15,padding:"14px"}} onClick={startQuiz}>
            {lang==="gr"?"Προχωρήστε στο Quiz →":"Take the Quiz →"}
          </button>
        )}
        {done.includes(lesson.id) && (
          <button className="btn-base btn-outline" style={{width:"100%",justifyContent:"center"}} onClick={startQuiz}>
            {lang==="gr"?"Επανάληψη Quiz":"Retake Quiz"}
          </button>
        )}
      </div>
    );
  }

  // ── QUIZ ─────────────────────────────────────────────────────────────────────
  function Quiz() {
    const qs = LESSONS[lesson.id]?.quiz || [];
    const allAnswered = qs.every((_,i)=>answers[i]!==undefined);
    return (
      <div>
        <button onClick={()=>setPhase("read")} style={{display:"flex",alignItems:"center",gap:6,background:"none",border:"none",cursor:"pointer",color:"var(--text-muted)",fontSize:12,fontWeight:700,marginBottom:16,padding:0}}>
          <Icon name="back" size={14}/> {lang==="gr"?"Πίσω στο μάθημα":"Back to lesson"}
        </button>
        <div style={{fontWeight:800,fontSize:16,color:"var(--text-primary)",marginBottom:4}}>{lesson.title}</div>
        <div style={{fontSize:12,color:"var(--text-muted)",marginBottom:20}}>{lang==="gr"?"Quiz":"Quiz"} · {qs.length} {lang==="gr"?"ερωτήσεις":"questions"}</div>

        <div style={{display:"flex",flexDirection:"column",gap:20}}>
          {qs.map((q,qi)=>(
            <div key={qi} style={{background:"var(--surface)",border:"1.5px solid var(--border)",borderRadius:16,padding:"16px 18px"}}>
              <div style={{fontWeight:700,fontSize:14,color:"var(--text-primary)",marginBottom:12}}>
                <span style={{color:"var(--green)",fontWeight:900,marginRight:6}}>{qi+1}.</span>{q.q}
              </div>
              <div style={{display:"flex",flexDirection:"column",gap:7}}>
                {q.opts.map((opt,oi)=>(
                  <div key={oi} onClick={()=>setAnswers(a=>({...a,[qi]:oi}))}
                    style={{padding:"10px 14px",borderRadius:10,border:`1.5px solid ${answers[qi]===oi?"var(--green)":"var(--border)"}`,background:answers[qi]===oi?"var(--green-light)":"var(--surface2)",cursor:"pointer",fontSize:13,fontWeight:answers[qi]===oi?700:500,color:answers[qi]===oi?"var(--green)":"var(--text-secondary)",transition:"all 0.12s",display:"flex",alignItems:"center",gap:10}}>
                    <div style={{width:20,height:20,borderRadius:"50%",border:`2px solid ${answers[qi]===oi?"var(--green)":"var(--border)"}`,background:answers[qi]===oi?"var(--green)":"transparent",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                      {answers[qi]===oi && <div style={{width:8,height:8,borderRadius:"50%",background:"#fff"}}/>}
                    </div>
                    {opt}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <button className="btn-base btn-green" disabled={!allAnswered} onClick={submitQuiz}
          style={{width:"100%",justifyContent:"center",fontSize:15,padding:"14px",marginTop:20,opacity:allAnswered?1:0.5}}>
          {lang==="gr"?"Υποβολή Απαντήσεων":"Submit Answers"}
        </button>
      </div>
    );
  }

  // ── QUIZ RESULT ───────────────────────────────────────────────────────────────
  function QuizResult() {
    const qs    = LESSONS[lesson.id]?.quiz || [];
    const score = quizScore();
    const total = quizTotal();
    const pass  = passed();
    return (
      <div>
        {/* Score banner */}
        <div style={{background:pass?"var(--green)":"#FEF0ED",border:`2px solid ${pass?"var(--green)":"#FACFC8"}`,borderRadius:20,padding:"24px",textAlign:"center",marginBottom:20}}>
          <div style={{fontFamily:"Bebas Neue,sans-serif",fontSize:64,color:pass?"var(--lime)":"var(--danger)",lineHeight:1,letterSpacing:2}}>{score}/{total}</div>
          <div style={{fontWeight:800,fontSize:18,color:pass?"#fff":"var(--danger)",marginTop:4}}>{pass?(lang==="gr"?"Πέρασες! 🎉":"Passed! 🎉"):(lang==="gr"?"Δοκίμασε ξανά":"Try Again")}</div>
          <div style={{fontSize:13,color:pass?"rgba(255,255,255,0.75)":"#991B1B",marginTop:6}}>
            {Math.round((score/total)*100)}% · {lang==="gr"?"Απαιτείται 75% για πέρασμα":"75% required to pass"}
          </div>
        </div>

        {/* Answer review */}
        <div style={{display:"flex",flexDirection:"column",gap:12,marginBottom:20}}>
          {qs.map((q,qi)=>{
            const chosen  = answers[qi];
            const correct = q.correct;
            const isRight = chosen===correct;
            return (
              <div key={qi} style={{background:"var(--surface)",border:`1.5px solid ${isRight?"#86EFAC":"#FECACA"}`,borderRadius:14,padding:"14px 16px"}}>
                <div style={{fontWeight:700,fontSize:13,color:"var(--text-primary)",marginBottom:10}}>
                  <span style={{marginRight:6}}>{isRight?"✅":"❌"}</span>{q.q}
                </div>
                <div style={{display:"flex",flexDirection:"column",gap:5}}>
                  {q.opts.map((opt,oi)=>{
                    const isCorrect = oi===correct;
                    const isChosen  = oi===chosen;
                    let bg = "var(--surface2)", color = "var(--text-muted)", border = "var(--border)";
                    if (isCorrect) { bg="#D1FAE5"; color="#065F46"; border="#34D399"; }
                    else if (isChosen && !isCorrect) { bg="#FEE2E2"; color="#991B1B"; border="#FCA5A5"; }
                    return (
                      <div key={oi} style={{padding:"8px 12px",borderRadius:8,background:bg,border:`1px solid ${border}`,fontSize:12,fontWeight:isCorrect||isChosen?700:400,color}}>
                        {isCorrect?"✓ ":isChosen?"✗ ":""}{opt}
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>

        <div style={{display:"flex",gap:10}}>
          {pass ? (
            <button className="btn-base btn-lime" style={{flex:1,justifyContent:"center",padding:"13px"}} onClick={completeLesson}>
              <Icon name="check" size={15}/>{lang==="gr"?"Ολοκλήρωση Μαθήματος":"Complete Lesson"}
            </button>
          ) : (
            <>
              <button className="btn-base btn-green" style={{flex:1,justifyContent:"center"}} onClick={()=>{setPhase("quiz");setAnswers({});}}>
                {lang==="gr"?"Δοκίμασε ξανά":"Try Again"}
              </button>
              <button className="btn-base btn-outline" onClick={()=>setPhase("read")}>
                {lang==="gr"?"Διάβασε ξανά":"Re-read"}
              </button>
            </>
          )}
        </div>
      </div>
    );
  }

  // ── MAIN RENDER ───────────────────────────────────────────────────────────────
  // Mobile: drill-down
  if (isMobile) {
    if (lesson) {
      if (phase==="quiz")   return <div className="anim-fade"><Quiz/></div>;
      if (phase==="result") return <div className="anim-fade"><QuizResult/></div>;
      return <div className="anim-fade"><LessonReader/></div>;
    }
    if (chapter) return <div className="anim-fade"><LessonList ch={chapter}/></div>;
    return <div className="anim-fade"><ChapterList/></div>;
  }

  // Desktop: sidebar + main
  return (
    <div className="anim-fade academy-layout">
      <div style={{overflowY:"auto"}}><ChapterList/></div>
      <div style={{overflowY:"auto"}}>
        {lesson
          ? (phase==="quiz" ? <Quiz/> : phase==="result" ? <QuizResult/> : <LessonReader/>)
          : chapter
            ? <LessonList ch={chapter}/>
            : (
              <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",minHeight:360,textAlign:"center",color:"var(--text-muted)",gap:10,padding:32}}>
                <span style={{fontSize:48}}>📚</span>
                <div style={{fontWeight:800,fontSize:17,color:"var(--text-primary)"}}>{lang==="gr"?"Επίλεξε ένα κεφάλαιο":"Select a chapter to get started"}</div>
                <div style={{fontSize:13}}>{ACADEMY.length} {lang==="gr"?"κεφάλαια":"chapters"} · {totalLessons} {lang==="gr"?"μαθήματα από τα PG SOPs":"lessons based on PG SOPs"}</div>
              </div>
            )
        }
      </div>
    </div>
  );
}

